import { PlayableWheel } from '../components/features/PlayableWheel';

/** Player view of the main paid wheel. */
export function WheelPage() {
  return <PlayableWheel wheelId="main" />;
}
